import { getAuthConfig } from './config';
import apiHelper from './index';

async function getAllDepartmentsOfOrg(orgName, spinner = true) {
  return await apiHelper.get(
    'organization/' + orgName + '/department/',
    spinner
  );
}

async function addNewOrganization(payload) {
  return await apiHelper.post('organization/', payload);
}

async function updateOrganization(orgName, payload) {
  return await apiHelper.patch(`organization/${orgName}/`, payload);
}

async function deleteOrganization(orgName) {
  return await apiHelper.remove(`organization/${orgName}/`);
}

async function createDepartment(orgName, departName, spinner = true) {
  return await apiHelper.post('organization/' + orgName + '/department/', {
    name: departName,
  });
}

async function switchOrganization(payload) {
  return await apiHelper.patch(
    `organization/organization-switch`,
    payload,
    false
  );
}

async function groupValidateVideos(query) {
  return await apiHelper.get(`organization/validation-groups/`, false, query);
}

async function fetchValidationVideosOfGroup(id) {
  return await apiHelper.get(
    `organization/validation-videos/retrieve/?group_id=${id}`,
    false
  );
}

async function createGroupValidateVideos(payload) {
  return await apiHelper.post(
    `organization/validation-groups/`,
    payload,
    false
  );
}

async function updateGroupValidateVideos(id, payload) {
  return await apiHelper.patch(
    `organization/validation-videos/${id}/`,
    payload,
    false
  );
}

async function deleteGroupValidateVideos(id, payload) {
  return await apiHelper.remove(`organization/validation-groups/${id}/`, false);
}

const switchUser = async (userEmail, spinner = true) => {
  return await apiHelper.patch(
    `organization/organization-switch/${userEmail}/`,
    spinner,
    getAuthConfig()
  );
};

async function createKaizenBucket(payload) {
  return await apiHelper.post('organization/create_kaizen_bucket', payload);
}

async function getPaginatedOrganizations(query, spinner = true) {
  return await apiHelper.get(
    'organization/get_organizations?' + query,
    spinner
  );
}

async function getParentCompanies(spinner = false) {
  return await apiHelper.get('organization/parent_companies', spinner);
}

async function getOrganizationsByTag(tag, spinner = true) {
  return await apiHelper.get(
    `organization/get_organizations?tag=${encodeURIComponent(tag)}`,
    spinner
  );
}

async function createValidationRun(payload) {
  return await apiHelper.post(`organization/validation-runs/`, payload, false);
}

async function setProxyServerSetting(useProxyServer, orgNameToDisplay) {
  return await apiHelper.patch(
    `organization/${orgNameToDisplay}/`,
    { use_proxy_server: useProxyServer },
    true
  );
}

async function getKaizenModules() {
  return await apiHelper.get(`/organization/kaizen-modules`, false);
}

async function getUserModules(orgName) {
  return await apiHelper.get(`/organization/${orgName}/modules`, false);
}

async function updateKaizenModules(orgNameToDisplay, payload) {
  return await apiHelper.patch(
    `organization/${orgNameToDisplay}/modules`,
    payload
  );
}

export default {
  deleteGroupValidateVideos,
  updateGroupValidateVideos,
  createGroupValidateVideos,
  groupValidateVideos,
  getAllDepartmentsOfOrg,
  createDepartment,
  switchOrganization,
  createKaizenBucket,
  switchUser,
  getPaginatedOrganizations,
  addNewOrganization,
  updateOrganization,
  deleteOrganization,
  fetchValidationVideosOfGroup,
  createValidationRun,
  setProxyServerSetting,
  getKaizenModules,
  updateKaizenModules,
  getUserModules,
  getParentCompanies,
  getOrganizationsByTag,
};
